import { Injectable, inject } from '@angular/core';
import { CoordinateSystem, GeoBrowserService, MapColors, InteractionService } from '@next/arable-lib/geo';
import { select, Store } from '@ngrx/store';
import { GeoJSON } from 'ol/format';
import VectorLayer from 'ol/layer/Vector';
import { Vector } from 'ol/source';
import { Stroke } from 'ol/style';
import Fill from 'ol/style/Fill';
import Style from 'ol/style/Style';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SiteState } from 'src/app/shared/models';

import { getSoilAnalysis, getSoilAnalysisLayerEnabled } from '../store/map.selectors';

@Injectable({
  providedIn: 'root',
})
export class GeoSoilAnalysisLayer implements InteractionService {
  private readonly store = inject<Store<SiteState>>(Store);

  readonly source = new Vector({
    wrapX: false,
  });

  readonly style = new Style({
    fill: new Fill({
      color: MapColors.soilAnalysesFill,
    }),
    stroke: new Stroke({
      color: MapColors.soilAnalysesStroke,
    }),
  });

  readonly layer = new VectorLayer({
    source: this.source,
    style: this.style,
    zIndex: 2,
  });

  private reader = new GeoJSON({
    dataProjection: CoordinateSystem.WorldGeodetic,
    featureProjection: CoordinateSystem.PseudoMercator,
  });
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  init(geoService: GeoBrowserService): void {
    geoService.map.addLayer(this.layer);
    this.store.pipe(select(getSoilAnalysis), takeUntil(this.destroyed$)).subscribe((features) => {
      this.source.clear();
      features
        .filter((featureEntity) => featureEntity.borderData)
        .forEach((featureEntity) => {
          const feature = this.reader.readFeature(featureEntity.borderData);
          feature.setId(featureEntity.borderData.id);
          this.source.addFeature(feature);
        });
    });

    this.store
      .pipe(select(getSoilAnalysisLayerEnabled), takeUntil(this.destroyed$))
      .subscribe((enabled) => {
        this.layer.setVisible(enabled);
      });
  }

  start(_: GeoBrowserService): void { }

  stop(_: GeoBrowserService): void { }

  destroy(geoService: GeoBrowserService) {
    this.layer.dispose();
    geoService.map.removeLayer(this.layer);
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
